/**
 * These keys are used for navigating combobox UI components.
 *
 * UP: Select the previous item in the list.
 * DOWN: Select the next item in the list.
 * ENTER / TAB: Complete input with the current selection.
 * ESC: Deselect the current selection and hide the list.
 */
import { DOWN, ENTER, ESCAPE, TAB, UP } from '../key_codes';
export var comboBoxKeyCodes = {
    DOWN: DOWN,
    ENTER: ENTER,
    ESCAPE: ESCAPE,
    TAB: TAB,
    UP: UP,
};
